import React from "react";

import Vacancy from "../SearchResults/Vacancy";

function InlineDescriptiveSingleJob() {
  return <Vacancy showHead singleJobView />;
}

export default InlineDescriptiveSingleJob;
